import React from 'react';
import styled from 'styled-components';
import * as Icons from './Icons';

interface Props {
	image:
	| 'language'
	| 'close'
	| 'ellipses'
	| 'back'
	| 'logout'
	| 'minimise'
	| 'maximise'
	| 'notification'
	| 'notification-full'
	| 'send'
	| 'accordian'
	| 'mic'
	| 'uncheckedRadio'
	| 'checkedRadio'
	| 'share'
	| 'refresh'
	| 'pencil';
	size: 'normal' | 'large' | 'small';
	fill?: string;
	variant: 'filled' | 'empty';
	title?: any;
	onClick?: Function;
	pulse?: boolean;
	pressed?: boolean;
	hovered?: boolean;
	className?: string;
	fullColor?: boolean;
	disabled?: boolean;
	ariaLabelledBy?: string;
	channel?: string;
}

const IconButtonOuter = styled.div`
	border: ${(props: any) => {
		return props.variant === 'filled'
			? `1px solid rgba(255, 255, 255, 0.3)`
			: '';
	}};
	cursor: pointer;
	position: relative;
	background-color: ${(props: any) => {
		return props.fill && props.variant === 'filled'
			? props.fill
			: props.variant === 'empty'
				? ''
				: 'rgba(60, 60, 60, 0.8)';
	}};

	& .empty {
		fill: ${(props: any) => {
		return props.fill
			? props.fullColor
				? props.fill
				: props.fill + 'BF'
			: props.channel == 'whatsapp'
				? '#fff'
				: ' #000000BF';
	}} !important;
	}
	button {
		&:focus-visible {
			background-color: ${(props: any) => {
		return props.fill && props.variant === 'empty'
			? props.fill + '33'
			: props.variant === 'empty'
				? 'rgba(0, 0, 0, 0.2)'
				: '';
	}};
		}
	}

	padding: ${(props: any) => {
		return props.variant === 'empty' ? '2px' : '0';
	}};
	border-radius: 100%;
	width: 30px;
	height: 30px;

	&.disabled-icon {
		cursor: not-allowed;
	}

	&:hover:not(.pulse):not(.disabled-icon),
	&.hovered:not(.pulse) {
		background-color: ${(props: any) => {
		return props.fill && props.variant === 'empty'
			? props.fill + '1a'
			: props.variant === 'empty'
				? 'rgba(0, 0, 0, 0.1)'
				: '';
	}};

		& .empty {
			fill: ${(props: any) => {
		return props.fill
			? props.channel == 'whatsapp'
				? '#fff'
				: props.fill
			: '#000000';
	}} !important;
		}
	}
	&:active,
	&:focus,
	&.pressed {
		background-color: ${(props: any) => {
		return props.fill && props.variant === 'empty'
			? props.fill + '33'
			: props.variant === 'empty'
				? 'rgba(0, 0, 0, 0.2)'
				: '';
	}};
	}
	&.pulse {
		&::before {
			content: '';
			position: absolute;
			inset: 0;
			z-index: 1;
			transform: translate(-50%, -50%);
			top: 50%;
			left: 50%;
			background-color: ${(props: any) => {
		return props.fill && props.variant === 'empty'
			? props.fill + '80'
			: props.variant === 'empty'
				? 'rgba(0, 0, 0, 0.5)'
				: '';
	}};
			opacity: 0.2;
			border: 1px solid
				${(props: any) => {
		return props.fill && props.variant === 'empty'
			? props.fill
			: props.variant === 'empty'
				? 'rgba(0, 0, 0)'
				: '';
	}};
			animation: 2s ease-in-out infinite dripple;
			border-radius: 100%;
		}

		height: 40px;
		width: 40px;
		.empty,
		.filled {
			animation: 2s ease-in-out infinite drippleMic;
		}
	}

	@keyframes drippleMic {
		0% {
			fill: ${(props: any) => {
		return props.fill && props.variant === 'empty'
			? props.fill
			: props.variant === 'empty'
				? 'rgba(0, 0, 0)'
				: '';
	}};
		}

		50% {
			fill: ${(props: any) => {
		return props.fill && props.variant === 'empty'
			? props.fill + '80'
			: props.variant === 'empty'
				? 'rgba(0, 0, 0, 0.5)'
				: '';
	}};
		}

		100% {
			fill: ${(props: any) => {
		return props.fill && props.variant === 'empty'
			? props.fill
			: props.variant === 'empty'
				? 'rgba(0, 0, 0)'
				: '';
	}};
		}
	}

	@keyframes dripple {
		0% {
			width: 32px;
			height: 32px;
		}

		50% {
			width: 40px;
			height: 40px;
			opacity: 0.1;
		}

		100% {
			width: 32px;
			height: 32px;
		}
	}
`;

export default function IconButton(props: Props) {
	const renderIcon = (item: string) => {
		switch (item) {
			case 'language':
				return <Icons.Language {...props} fill='' />;
			case 'close':
				return <Icons.Close {...props} fill='' />;
			case 'ellipses':
				return <Icons.Ellipses {...props} fill='' />;
			case 'back':
				return <Icons.Back {...props} fill='' />;
			case 'logout':
				return <Icons.Logout {...props} fill='' />;
			case 'minimise':
				return <Icons.Minimise {...props} fill='' />;
			case 'maximise':
				return <Icons.Maximise {...props} fill='' />;
			case 'notification':
				return <Icons.Notification {...props} fill='' />;
			case 'notification-full':
				return <Icons.NotificationFull {...props} fill='' />;
			case 'send':
				return <Icons.Send {...props} fill='' />;
			case 'accordian':
				return <Icons.Accordian {...props} fill='' />;
			case 'mic':
				return <Icons.Mic {...props} />;
			case 'share':
				return <Icons.Share {...props} fill='' />;
			case 'refresh':
				return <Icons.Refresh {...props} fill='' />;
			case 'uncheckedRadio':
				return <Icons.UncheckedRadio {...props} fill='' />;
			case 'checkedRadio':
				return <Icons.CheckedRadio {...props} fill='' />;
			case 'pencil':
				return <Icons.ThemedPencil {...props} fill='' />;
			default:
				return <Icons.Close {...props} fill='' />;
		}
	};
	return (
		<IconButtonOuter
			{...props}
			title={null}
			className={`${props.className} icon-button ${props.disabled ? 'disabled-icon' : ''
				} ${props.pressed ? 'pressed' : ''} ${props.hovered ? 'hovered' : ''} ${props.pulse ? 'pulse' : ''
				}`}
			onClick={() => {
				if (!props.disabled) props.onClick && props.onClick();
			}}
			style={{
				marginRight:
					!['share', 'accordian'].includes(props.image) ||
						(props.image === 'share' && props.pressed)
						? '8px'
						: '',
			}}
		>
			<button
				aria-labelledby={props.ariaLabelledBy}
				disabled={props.disabled}
				title={props.title}
				className={`inner-icon ${props.size} ${props.variant}`}
			>
				{renderIcon(props.image)}
			</button>
		</IconButtonOuter>
	);
}
